import React from 'react';
import './footer.scss';

export default function AppFooter() {
    return (
        <div>
            <div className="project-main-footer f-wrp">
                <div className="row">
                    <p style={{ color: "#fff" }}>
                        *Urgent Alert: Beware of Scams and Deceptive Actions*
                        It has come to our attention that there are unauthorized individuals falsely asserting their association with WDP.
                        When engaging with the organization, it is crucial to be vigilant and avoid any interactions with dubious communications
                        or proposals. Please refrain from involving third parties while conducting business with WDP.
                        Should you have inquiries or come across any alarming situations, promptly reach out to us via our official
                        communication platforms at legal@wdp-igo.org.
                        Rest assured that your safety and trust are of utmost importance to us. We appreciate your immediate attention
                        to this critical notice.
                    </p>
                </div>
                <div className="main-footer-container f-wrp">
                    <div className='copy-foot f-wrp'>
                        <div className="row">
                            <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                <div className="copy-txt f-wrp">
                                    <p>© Copyright 2024 by Wdp-igo.org</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}